var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-card card-outro"},[(_vm.isVisible)?_c('DashboardTrack',{attrs:{"readMore":true,"xp":_vm.stack.xp},on:{"swiperUpdate":_vm.swiperUpdate,"readMore":_vm.readMore}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }